import { createIcon } from './utils';

const InformationFill = createIcon(
  'InformationFill',
  'M12 21C7.0293 21 3 16.9707 3 12C3 7.0293 7.0293 3 12 3C16.9707 3 21 7.0293 21 12C21 16.9707 16.9707 21 12 21ZM11.1 11.1V16.5H12.9V11.1H11.1ZM11.1 7.5V9.3H12.9V7.5H11.1Z'
);

export default InformationFill;
